/**
 * This file is generated on build. To make changes, see /templates/constants.ts
 */
/**
 * @packageDocumentation
 * @module Voice
 * @internalapi
 */
const PACKAGE_NAME = '@twilio/voice-sdk';
const RELEASE_VERSION = '2.12.3';
const SOUNDS_BASE_URL = 'https://sdk.twilio.com/js/client/sounds/releases/1.0.0';
const COWBELL_AUDIO_URL = `${SOUNDS_BASE_URL}/cowbell.mp3?cache=${RELEASE_VERSION}`;
const ECHO_TEST_DURATION = 20000;
export { COWBELL_AUDIO_URL, ECHO_TEST_DURATION, PACKAGE_NAME, RELEASE_VERSION, SOUNDS_BASE_URL, };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vbGliL3R3aWxpby9jb25zdGFudHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFDSDs7OztHQUlHO0FBRUgsTUFBTSxZQUFZLEdBQUcsbUJBQW1CLENBQUM7QUFDekMsTUFBTSxlQUFlLEdBQUcsUUFBUSxDQUFDO0FBQ2pDLE1BQU0sZUFBZSxHQUFHLHdEQUF3RCxDQUFDO0FBQ2pGLE1BQU0saUJBQWlCLEdBQUcsR0FBRyxlQUFlLHNCQUFzQixlQUFlLEVBQUUsQ0FBQztBQUNwRixNQUFNLGtCQUFrQixHQUFHLEtBQUssQ0FBQztBQUVqQyxPQUFPLEVBQ0wsaUJBQWlCLEVBQ2pCLGtCQUFrQixFQUNsQixZQUFZLEVBQ1osZUFBZSxFQUNmLGVBQWUsR0FDaEIsQ0FBQyJ9